import React from 'react';
import Aux from '../../../hoc/Aux';
import DOMPurify from 'dompurify';

const DOMPurifyConfig = {
  ALLOWED_TAGS: ['a', 'h3', 'h4', 'p', 'i', 'b', 'ul', 'li', 'strong', 'span', 'table', 'tr', 'td', 'thead', 'tbody', 'th', 'tfoot'],
  ALLOWED_ATTR: ['href']
}

const serviceType = (props) => {
  let label = props.name;
  label += (props.price!=null)? " ("+props.price+"€)":"";
  const hasDescription = (props.description.length>0);

  let descriptionBtn = null;
  if(hasDescription){
    if(props.isDescriptionActive){
      descriptionBtn = <span className="service-type-description-toggle-btn pl-1" onClick={props.onDescriptionHide}>peida kirjeldus</span>
    }else{
      descriptionBtn = <span className="service-type-description-toggle-btn pl-1" onClick={props.onDescriptionShow}>kuva kirjeldus</span>
    }
  }

  let descriptionElem = null;
  if(hasDescription && props.isDescriptionActive){
    const sanitizedDescription = DOMPurify.sanitize(props.description, DOMPurifyConfig);
    descriptionElem = (<div className="pt-2 pl-2 pb-2 mt-2 mb-2" style={{"borderLeft": "4px #ececec solid", "background": "#fdfdfd", "boxShadow": "0 3px 3px 1px #f7f7f7"}} dangerouslySetInnerHTML={{__html: sanitizedDescription}}></div>);
  }  

  
  return (
    <Aux>
      <div className="mt-1 form-check">
        <input type="checkbox" id={`inline-${props.id}`} onChange={props.changed} defaultChecked={props.isChecked? true:false} className="form-check-input"/>
        <label title="" htmlFor={`inline-${props.id}`} className="form-check-label">{label}</label>
        {descriptionBtn}
        {descriptionElem}

      </div>

    </Aux>
  )

}

export default serviceType;